import React from 'react';
import { Button } from '../../../../../Utility/Button';
import { RootState, useAppSelector } from '../../../../../../store';

type Props = {
    isLoading: boolean;
    isNew: boolean;
    hasServerUrl: boolean;
    hasUnsavedChanges: boolean;
    onCancel: () => void;
    onTest: () => void;
    onSubmit: (e?: React.FormEvent) => void;
    onSync: () => void;
};

const FormControls: React.FC<Props> = ({ isLoading, isNew, hasUnsavedChanges, onCancel, onTest, onSubmit, onSync }) => {
    const i18n = useAppSelector((state: RootState) => state.i18n.i18n);
    return (
        <div className="flex justify-end gap-4">
            <Button onClick={onCancel} variant="secondary">
                {i18n.translate({ id: 'form.cancel', sourceName: 'MCP' })}
            </Button>
            {!isNew && (
                <Button variant="secondary" onClick={onSync}>
                    {i18n.translate({ id: 'common.syncTools', sourceName: 'MCP' })}
                </Button>
            )}
            {hasUnsavedChanges || isNew ? (
                <Button onClick={() => onSubmit()} disabled={isLoading} variant="primary">
                    {isLoading
                        ? i18n.translate({ id: 'form.saving', sourceName: 'MCP' })
                        : isNew
                        ? i18n.translate({ id: 'form.create', sourceName: 'MCP' })
                        : i18n.translate({ id: 'form.update', sourceName: 'MCP' })}
                </Button>
            ) : !isNew&&(
                <Button onClick={onTest} variant="secondary" tooltipText={hasUnsavedChanges ? i18n.translate({ id: 'form.testConnection.tooltip', sourceName: 'MCP' }) : undefined}>
                    {i18n.translate({ id: 'form.testConnection', sourceName: 'MCP' })}
                </Button>
            )}
        </div>
    );
};

export default FormControls;
